import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { SidebarComponent } from './sidebar/sidebar.component';
import { RouterModule } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { GenericDialogComponent } from '../shared/components/generic-dialog/generic-dialog.component';



@NgModule({
  declarations: [
    HeaderComponent,
    SidebarComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    FormsModule,
    GenericDialogComponent
  ],
  exports: [
    HeaderComponent,
    SidebarComponent,
  ]
})
export class LayoutModule { }
